import * as TeamApis from '../../apis/team';
import * as TeamActionTypes from '../../types/team';

export const fetch = ({ userId, teamId }) => async(dispatch) => {
    const team = await TeamApis.fetch(userId, teamId);
    dispatch(setTeam(team));
};

export const setTeam = (team) => ({
    type: TeamActionTypes.SET_TEAM,
    payload: team
});
